<template>
  <div class="container">
    <div class="alarm_main">
      <iframe
        id="iframeBox"
        name="iframeBox"
        seamless
        scrolling="no"
        :src="iframeUrl"
      ></iframe>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      iframeUrl: ''
    }
  },
  mounted() {
    const uname = this.$store.state.user.name
    const uId= this.$store.state.user.id
    this.iframeUrl='../../../static/baojing/alarmWeb.html?username='+uname+'&userId='+uId+'&token='+this.$store.state.user.token
    if(this.$i18n.locale==='zh-CN'){
      this.iframeUrl='../../../static/alarm/alarmWeb.html?username='+uname+'&userId='+uId+'&token='+this.$store.state.user.token
    }else{
      this.iframeUrl='../../../static/alarm_en/alarmWeb.html?username='+uname+'&userId='+uId+'&token='+this.$store.state.user.token
    }
  }
}
</script>
<style scoped>
.container {
  position: relative;
	width: 100%;
	height:100%;
	background:url('../../assets/datacount.png') no-repeat;
	background-size: cover;
}
.alarm_main{
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  overflow: hidden;
}

#iframeBox{
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin:0;
}
</style>